import { type } from 'arktype'

export const nlAovqlProfessionalClasses = ['1', '2', '3', '4'] as const
export const nlAovqlProfessionalClassSchema = type('===', ...nlAovqlProfessionalClasses)
export type NlAovqlProfessionalClass = typeof nlAovqlProfessionalClassSchema.infer
